import { formatDateToHumanDate } from "common/utils/formDateToHumanTime";
import { isEmpty } from "common/utils/isEmpty";
import {
  ownerKindEnum,
} from 'common/utils/enums';
import { Tag } from "@chakra-ui/react";

const createPropertyOptionMenu = (obj) => {
  if (isEmpty(obj)) return [];

  return obj?.map(
    // eslint-disable-next-line no-unused-vars
    ({
      createdAt,
      id,
      name,
      displayAddress,
      address,
      leaveAnytimeRate,
      cancelAnytimeRate,
      propertyDefaults,
      ...res
    }) => ({
      label: (
        <div className="w-full flex gap-2 justify-between">
          <div className="text-md font-medium">{name || "Building"}</div>
          <div className="hidden sm:block text-md font-normal text-gray-500">
            {address?.streetAddress1}, {address?.city}
          </div>
        </div>
      ),
      value: id,
      name: name,
      leaveAnytimeRate: leaveAnytimeRate,
      cancelAnytimeRate: cancelAnytimeRate,
      address: address,
      displayAddress: `${address?.streetAddress1}, ${address?.city}, ${address?.state} ${address?.postalCode}`,
      propertyDefaults: propertyDefaults,
      owner: res?.owner,
    })
  );
};

const createTenantOptionMenu = (obj) => {
  if (isEmpty(obj)) return [];

  return obj?.map(
    // eslint-disable-next-line no-unused-vars
    ({ createdAt, id, name, firstName, lastName, email, ...res }) => ({
      label: (
        <div className="w-full flex gap-2 justify-between">
          <div className="text-md font-medium">
            {name || `${firstName} ${lastName}` || "Member"}
          </div>
          <div className="hidden sm:grid md:grid-cols-[1fr_100px] gap-2 text-md font-normal text-gray-500">
            <span className="hidden md:block">{email}</span>
            <span className="text-md text-gray-500 text-right">
              {formatDateToHumanDate(createdAt)}
            </span>
          </div>
        </div>
      ),
      value: id,
      firstName: firstName,
      lastName: lastName,
      email: email,
    })
  );
};

const createOwnerOptionMenu = (obj) => {
  if (isEmpty(obj?.data)) return [];

  return obj?.data?.map(({ id, name, kind, ...res }) => ({
    label: (
      <div className="w-full flex gap-2 justify-between">
        <div className="text-md font-medium flex gap-2 items-center">
          {name || "Owner"}
          <Tag
            colorScheme={kind === ownerKindEnum.MANAGER ? "blue" : "green"}
            size="sm"
          >
            {kind === ownerKindEnum.MANAGER ? "Manager" : "Owner"}
          </Tag>
        </div>
        <div className="text-md font-normal text-gray-500">{id}</div>
      </div>
    ),
    value: id,
    name: name,
    kind: kind,
  }));
};

// Custom Filter Option for Select Input
const propertyFilterOption = (option, inputValue) => {
  // 'option.data' holds the original option object
  const { name, displayAddress } = option.data; 
  return name?.toLowerCase().includes(inputValue?.toLowerCase()) || displayAddress?.toLowerCase().includes(inputValue?.toLowerCase());
};

const ownerFilterOption = (option, inputValue) => {
  // 'option.data' holds the original option object
  const { name, kind } = option.data; 
  return (name?.toLowerCase().includes(inputValue?.toLowerCase()) || kind?.toLowerCase().includes(inputValue?.toLowerCase()));
};

const tenantFilterOption = (option, inputValue) => {
  // 'option.data' holds the original option object
  const { firstName, lastName, email } = option.data; 
  return (firstName?.toLowerCase().includes(inputValue?.toLowerCase()) || lastName?.toLowerCase().includes(inputValue?.toLowerCase()) || email?.toLowerCase().includes(inputValue?.toLowerCase()));
};

export { propertyFilterOption, ownerFilterOption, tenantFilterOption };

export {
  createPropertyOptionMenu,
  createTenantOptionMenu,
  createOwnerOptionMenu,
};
